export default __webpack_public_path__ + "static/media/slider1.5ae87574.png";